export default {
    data() {
        return {
            link_dialog: false,
            dialog_type: 'link',
            new_link: false,
            link_slug: '',
        };
    },
    methods: {
        open_dialog(type, new_link, id) {
            if (type.indexOf('social') >= 0) this.dialog_type = 'social';
            if (type.indexOf('footer') >= 0) this.dialog_type = 'footer';
            if (type === 'link') this.dialog_type = 'link';
            this.new_link = new_link;

            if (!this.new_link) {
                this.link_slug = id;
            } else {
                this.link_slug = '';
            }

            this.link_dialog = true;
        },
        clear_tree() {
            this.link_slug = '##PLACEHOLDER##';
            this.link_dialog = false;
            this.$store.dispatch('clearManipulatedData');
        },
    },
};
